// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DentalV1GetsafeDe = z.object({
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 65 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  tariff_line: z.enum(['75', '90', '100']),
  previous_insurer: z.string().min(1).optional(),
  previous_insurance: z.enum(['unknown', 'true', 'false']).optional(),
  health_insurance_type: z
    .enum(['private', 'statutory', 'free_healthcare_for_civil_servants'])
    .optional(),
  number_of_missing_teeth: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2', '3']))
    .pipe(z.coerce.number())
    .optional(),
  prevention_bonus_clause: z.boolean().optional(),
  previous_insurance_end_date: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .nullish()
    .transform((value) => {
      if (value === undefined || value === null) {
        return value
      }
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  previous_insurance_start_date: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  treated_peridontal_disease_3_years: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  previous_insurance_covers_min_75_percent_dental_replacements: z.boolean().optional(),
})

const Schema_DentalV1GetsafeDe = BaseSchema_DentalV1GetsafeDe.superRefine((values, ctx) => {
  if (
    values['previous_insurance'] !== undefined &&
    ['true'].includes(values['previous_insurance'])
  ) {
    if (values['previous_insurer'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'string',
        received: 'undefined',
        message: 'Required',
        path: ['previous_insurer'],
      })
    }
  }
}).superRefine((values, ctx) => {
  if (
    values['previous_insurance'] !== undefined &&
    ['true'].includes(values['previous_insurance'])
  ) {
    if (values['previous_insurance_start_date'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'date',
        received: 'undefined',
        message: 'Required',
        path: ['previous_insurance_start_date'],
      })
    }
  }
})

export default Schema_DentalV1GetsafeDe
